<template>
  <section v-if="!equipe" class="painel-atividades">
    <header class="dashboard-header">
      <div>
        <h3>Lista de atividades</h3>
        <p>
          Acompanhe as atividades cadastradas nesta ação de extensão
        </p>
      </div>


    </header>

    <div class="painel-listagem">
      <Carregamento v-if="carregando" :mensagemCarregamento="'Carregando atividades'" />

      <div v-else-if="erro" class="estado-lista erro-lista">
        <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>

        <p>{{ erro }}</p>

        <button type="button" @click="carregarAtividades">
          Tentar novamente
        </button>
      </div>

      <div v-else-if="atividades.length === 0" class="estado-lista">
        <i class="fa-regular fa-folder-open" aria-hidden="true"></i>

        <p>Nenhuma atividade encontrada.</p>
      </div>

      <div v-else class="tabela-container">
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Data de cadastro</th>
              <th>Nº de participantes</th>
              <th>Status</th>
              <th>
                <span class="sr-only">Ações</span>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="atividade in atividades" :key="atividade.id">
              <td>
                <span class="atividade-nome">
                  {{ atividade.nome || "Não informado" }}
                </span>
              </td>

              <td>
                <span class="data-atividade">
                  {{ formatarData(atividade.dataCadastro) }}
                </span>
              </td>

              <td>
                <span class="participantes">
                  {{ atividade.numeroDeParticipantes ?? 0 }}
                </span>
              </td>

              <td>
                <span class="status" :class="classeStatus(atividade.status)">
                  {{ formatarEnum(atividade.status) }}
                </span>
              </td>

              <td class="celula-acoes">
                <button type="button" class="btn-opcoes" @click="abrirMenuOpcoes(atividade)">
                  Opções
                  <i class="fa-solid fa-ellipsis-vertical" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer v-if="!carregando && !erro && atividades.length > 0" class="paginacao">
        <span>
          Exibindo
          {{ inicioPagina }}–{{ fimPagina }}
          de
          {{ totalAtividades }}
        </span>

        <div>
          <button type="button" :disabled="paginaAtual === 0" aria-label="Página anterior" @click="paginaAnterior">
            ‹
          </button>

          <span>
            Página {{ paginaAtual + 1 }} de
            {{ totalPaginas }}
          </span>

          <button type="button" :disabled="paginaAtual >= totalPaginas - 1" aria-label="Próxima página"
            @click="proximaPagina">
            ›
          </button>
        </div>
      </footer>
    </div>
  </section>

  <RouterView />

  <div v-if="atividadeSelecionada" class="modal-overlay" @click.self="fecharMenuOpcoes">
    <div class="modal-opcoes" role="dialog" aria-modal="true" aria-labelledby="titulo-opcoes">
      <div class="modal-header">
        <div>
          <span class="modal-label">Atividade</span>

          <h4 id="titulo-opcoes">
            {{ atividadeSelecionada.nome }}
          </h4>
        </div>

        <button type="button" class="btn-fechar-modal" aria-label="Fechar" @click="fecharMenuOpcoes">
          ×
        </button>
      </div>

      <div class="modal-acoes">
        <button v-if="podeAcessarFrequencia" type="button" class="acao-modal"
          @click="abrirFrequencia(atividadeSelecionada)">
          <span class="icone-acao">
            <i class="fa-solid fa-clipboard-check" aria-hidden="true"></i>
          </span>

          <span class="texto-acao">
            <strong>Frequência</strong>
            <small>Gerenciar a frequência dos participantes</small>
          </span>

          <i class="fa-solid fa-chevron-right seta-acao" aria-hidden="true"></i>
        </button>

        <button type="button" class="acao-modal" @click="abrirEquipe(atividadeSelecionada)">
          <span class="icone-acao">
            <i class="fa-solid fa-users" aria-hidden="true"></i>
          </span>

          <span class="texto-acao">
            <strong>Equipe</strong>
            <small>Gerenciar a equipe da atividade</small>
          </span>

          <i class="fa-solid fa-chevron-right seta-acao" aria-hidden="true"></i>
        </button>

        <button type="button" class="acao-modal" @click="abrirAtividade(atividadeSelecionada.id)">
          <span class="icone-acao">
            <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
          </span>

          <span class="texto-acao">
            <strong>Abrir atividade</strong>
            <small>Visualizar os detalhes da atividade</small>
          </span>

          <i class="fa-solid fa-chevron-right seta-acao" aria-hidden="true"></i>
        </button>

        <button v-if="podeEditar" type="button" class="acao-modal" @click="editarAtividade(atividadeSelecionada)">
          <span class="icone-acao">
            <i class="fa-solid fa-pen" aria-hidden="true"></i>
          </span>

          <span class="texto-acao">
            <strong>Editar</strong>
            <small>Alterar os dados da atividade</small>
          </span>

          <i class="fa-solid fa-chevron-right seta-acao" aria-hidden="true"></i>
        </button>

        <button v-if="podeEncerrar" type="button" class="acao-modal acao-perigosa"
          @click="encerrarAtividade(atividadeSelecionada.id)">
          <span class="icone-acao">
            <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
          </span>

          <span class="texto-acao">
            <strong>Encerrar atividade</strong>
            <small>Finalizar esta atividade</small>
          </span>

          <i class="fa-solid fa-chevron-right seta-acao" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>

  <FrequenciaEncontro v-if="$route.query.modal === 'frequencia-encontro'" @fechar="fecharTela" />

  <GestaoDeEquipe v-if="equipe" :atividadeId="atividadeEquipe?.id" :acaoId="props.acaoId"
    @fecharGestaoDeEquipe="fecharGestaoDeEquipe" />

  <FormCadastroAtividade v-if="route.query.modal === 'cadastrar-atividade'" :acaoId="props.acaoId" />

  <FormEditarAtividade v-if="route.query.modal === 'editar-atividade'" :acaoId="props.acaoId" />
</template>


<script setup>
import {
  computed,
  onMounted,
  ref,
} from "vue";

import {
  useRoute,
} from "vue-router";

import router from "@/router";

import FrequenciaEncontro from "@/components/encontros/FrequenciaEncontro.vue";
import GestaoDeEquipe from "@/components/atividades/GestaoDeEquipe.vue";
import FormCadastroAtividade from "@/components/atividades/FormCadastroAtividade.vue";
import FormEditarAtividade from "@/components/atividades/FormEditarAtividade.vue";
import Carregamento from "@/components/common/Carregamento.vue";

import {
  formatarData,
  formatarEnum,
} from "@/utils/FormatarEntradas";

import atividadeService from "@/service/atividadeService";

const atividadeEquipe = ref(null);
const props = defineProps({
  acaoId: {
    type: String,
    required: true,
  },
});

const atividades = ref([]);
const equipe = ref(false);
const atividadeSelecionada = ref(null);
const carregando = ref(true);
const erro = ref(null);
const route = useRoute();

const paginaAtual = ref(0);
const tamanhoPagina = ref(10);
const totalPaginas = ref(0);
const totalAtividades = ref(0);

const inicioPagina = computed(() => {
  if (atividades.value.length === 0) {
    return 0;
  }

  return paginaAtual.value * tamanhoPagina.value + 1;
});

const fimPagina = computed(() => {
  return Math.min(
    (paginaAtual.value + 1) * tamanhoPagina.value,
    totalAtividades.value
  );
});

const STATUS_FINALIZADOS = [
  "CANCELADA",
  "ENCERRADA",
  "FINALIZAR",
  "FINALIZADO",
  "CONCLUIDA",
];

const podeAcessarFrequencia = computed(() => {
  if (!atividadeSelecionada.value) {
    return false;
  }

  return (
    atividadeSelecionada.value.modalidadeInscricao ===
    "NECESSITA_INSCRICAO" &&
    !STATUS_FINALIZADOS.includes(
      atividadeSelecionada.value.status
    )
  );
});


const podeEditar = computed(() => {
  if (!atividadeSelecionada.value) {
    return false;
  }

  return !STATUS_FINALIZADOS.includes(
    atividadeSelecionada.value.status
  );
});


const podeEncerrar = computed(() => {
  if (!atividadeSelecionada.value) {
    return false;
  }

  return !STATUS_FINALIZADOS.includes(
    atividadeSelecionada.value.status
  );
});


async function carregarAtividades() {
  try {
    carregando.value = true;
    erro.value = null;

    const response = await atividadeService.getAtividadesAcao(
      paginaAtual.value,
      tamanhoPagina.value,
      props.acaoId,
      true
    );

    atividades.value = response?.atividades ?? [];
    totalPaginas.value = response?.numPaginas ?? 0;
    totalAtividades.value = response?.totalElementos ?? 0;
  } catch (error) {
    console.error("Erro ao carregar atividades:", error);

    erro.value = "Erro ao carregar atividades.";
    atividades.value = [];
    totalPaginas.value = 0;
    totalAtividades.value = 0;
  } finally {
    carregando.value = false;
  }
}
async function paginaAnterior() {
  if (paginaAtual.value <= 0 || carregando.value) {
    return;
  }

  paginaAtual.value--;
  await carregarAtividades();
}

async function proximaPagina() {
  if (
    carregando.value ||
    paginaAtual.value >= totalPaginas.value - 1
  ) {
    return;
  }

  paginaAtual.value++;
  await carregarAtividades();
}


function classeStatus(status) {
  switch (status) {
    case "ENCERRADA":
      return "status-encerrada";

    case "EM_EXECUCAO":
      return "status-em-execucao";

    case "PROGRAMADA":
      return "status-programada";

    case "CANCELADA":
      return "status-cancelada";

    case "CONCLUIDA":
      return "status-concluida";

    case "FINALIZAR":
    case "FINALIZADO":
      return "status-finalizar";

    case "INSCRICOES_ABERTAS":
      return "status-aberta";

    default:
      return "status-padrao";
  }
}

function abrirMenuOpcoes(atividade) {
  atividadeSelecionada.value = atividade;
}


function fecharMenuOpcoes() {
  atividadeSelecionada.value = null;
}

function abrirFrequencia(atividade) {
  atividadeSelecionada.value = atividade;

  router.push({
    query: {
      modal: "frequencia-encontro",
      atividadeId: atividade.id,
    },
  });
}

function abrirAtividade(atividadeId) {
  fecharMenuOpcoes();

  router.push(
    `/acao/${props.acaoId}/atividades/${atividadeId}`
  );
}

function editarAtividade(atividade) {
  fecharMenuOpcoes();

  router.push({
    name: "editar-atividade",
    params: {
      id: props.acaoId,
      atividadeId: atividade.id,
    },
  });
}

function abrirEquipe(atividade) {
  atividadeEquipe.value = atividade;
  fecharMenuOpcoes();
  equipe.value = true;
}

async function fecharGestaoDeEquipe() {
  equipe.value = false;
  atividadeEquipe.value = null;
  await carregarAtividades();
}

async function encerrarAtividade(
  atividadeId
) {
  try {
    await atividadeService.encerrarAtividade(
      atividadeId
    );

    fecharMenuOpcoes();

    await carregarAtividades();
  } catch (error) {
    console.error(
      "Erro ao encerrar atividade:",
      error
    );
  }
}

function fecharTela() {
  router.push({
    query: {},
  });
}

onMounted(async () => {
  await carregarAtividades();
});
</script>


<style scoped>
.painel-atividades {
  width: 100%;
  color: var(--roxo-escuro);
}

.dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 24px;

  margin-bottom: 20px;
}

.dashboard-header h3 {
  margin: 0 0 4px;

  color: var(--branco);

  font-size: 1.2rem;
  font-weight: 700;
}

.dashboard-header p {
  margin: 0;

  color: var(--cinza-claro);

  font-size: 0.85rem;
}

.painel-listagem {
  overflow: hidden;

  border: 1px solid var(--roxo-superficie);
  border-radius: 15px;

  background: var(--branco);

  box-shadow:
    0 6px 20px hsla(258, 55%, 15%, 0.06);
}

.tabela-container {
  width: 100%;

  overflow-x: auto;
}

table {
  width: 100%;

  border-collapse: collapse;

  font-size: 0.78rem;
}

th {
  padding: 13px 16px;

  color: var(--cinza-medio);

  text-align: left;
  text-transform: uppercase;

  letter-spacing: 0.04em;

  background: var(--roxo-superficie);

  font-size: 0.68rem;

  white-space: nowrap;
}

td {
  max-width: 240px;

  padding: 15px 16px;

  border-top: 1px solid var(--roxo-superficie);

  color: var(--cinza-escuro);

  vertical-align: middle;
}

tbody tr {
  transition: background 0.2s ease;
}

tbody tr:hover {
  background: var(--roxo-superficie);
}

.atividade-nome {
  display: block;

  max-width: 280px;

  color: var(--cinza-escuro);

  font-weight: 600;
  line-height: 1.4;

  overflow-wrap: anywhere;
  word-break: break-word;
}

.data-atividade {
  color: var(--cinza-medio);

  white-space: nowrap;
}

.participantes {
  display: inline-flex;
  align-items: center;
  justify-content: center;



  color: var(--roxo-medio);

  font-size: 0.72rem;
  font-weight: 700;
}

.status {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 5px 9px;

  border-radius: 999px;

  font-size: 0.68rem;
  font-weight: 700;

  white-space: nowrap;
}

.status-encerrada {
  color: #9d2e39;
  background: #fde4e7;
}

.status-em-execucao {
  color: #9a5700;
  background: #fff1c7;
}

.status-programada {
  color: #5f6368;
  background: #eeeeee;
}

.status-cancelada {
  color: #9d2e39;
  background: #fde4e7;
}

.status-concluida {
  color: #12633c;
  background: #dff5e9;
}

.status-finalizar {
  color: #444;
  background: #e9e9e9;
}

.status-aberta {
  color: #6841a5;
  background: #eee9fa;
}

.status-padrao {
  color: var(--cinza-escuro);
  background: var(--roxo-superficie);
}

.celula-acoes {
  text-align: right;

  white-space: nowrap;
}

.btn-opcoes {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 7px;

  padding: 7px 11px;

  border-radius: 8px;

  color: var(--branco);
  background: var(--roxo-primario);

  font-size: 0.72rem;
  font-weight: 700;

  cursor: pointer;

  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
}

.btn-opcoes:hover {

  background: var(--roxo-medio);
}

.rodape-tabela {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-top: 1px solid var(--roxo-superficie);
  color: var(--cinza-medio);
  font-size: 0.73rem;
}

.paginacao {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-top: 1px solid var(--roxo-superficie);
  color: var(--cinza-medio);
  font-size: 0.73rem;
}

.paginacao>div {
  display: flex;
  align-items: center;
  gap: 9px;
}

.paginacao button {
  width: 32px;
  height: 32px;

  border: 1px solid var(--roxo-superficie);
  border-radius: 8px;

  color: var(--roxo-medio);
  background: var(--branco);

  font-size: 1.1rem;

  cursor: pointer;
}

.paginacao button:hover:not(:disabled) {
  background: var(--roxo-superficie);
}

.paginacao button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .paginacao {
    flex-direction: column;
    align-items: flex-start;
  }
}

.estado-lista {
  display: flex;

  min-height: 260px;

  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 12px;

  padding: 30px;

  color: var(--cinza-medio);

  text-align: center;
}

.estado-lista i {
  color: var(--roxo-claro);

  font-size: 2rem;
}

.estado-lista p {
  margin: 0;

  font-size: 0.86rem;
}

.estado-lista button {
  padding: 8px 12px;

  border: 0;
  border-radius: 8px;

  color: var(--branco);
  background: var(--roxo-medio);

  cursor: pointer;

  transition: background 0.2s ease;
}

.estado-lista button:hover {
  background: var(--roxo-primario);
}

.erro-lista i {
  color: var(--vermelho);
}

.modal-overlay {
  position: fixed;

  z-index: 9999;

  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 20px;


}

.modal-opcoes {
  width: 100%;
  max-width: 470px;

  overflow: hidden;

  border-radius: 15px;

  background: var(--branco);

  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.2);

  animation: aparecerModal 0.18s ease;
}

@keyframes aparecerModal {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  gap: 20px;

  padding: 20px;
  background-color: var(--roxo-primario);
}

.modal-label {
  display: block;

  margin-bottom: 5px;

  color: var(--branco);

  font-size: 0.68rem;
  font-weight: 700;

  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.modal-header h4 {
  max-width: 360px;

  margin: 0;

  color: var(--branco);

  font-size: 1rem;
  font-weight: 700;

  line-height: 1.35;

  overflow-wrap: anywhere;
  word-break: break-word;
}

.btn-fechar-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  width: 32px;
  height: 32px;

  padding: 0;

  border: 0;
  border-radius: 8px;

  color: var(--branco);
  background: transparent;

  font-size: 1.5rem;
  line-height: 1;

  cursor: pointer;

  transition:
    background 0.2s ease,
    color 0.2s ease;
}

.btn-fechar-modal:hover {
  color: var(--cinza-escuro);
  background: var(--roxo-superficie);
}

.modal-acoes {
  display: flex;
  flex-direction: column;

  padding: 8px;
}

.acao-modal {
  display: flex;
  align-items: center;

  width: 100%;

  gap: 12px;

  padding: 12px;

  border: 0;
  border-radius: 9px;

  color: var(--preto);
  background: transparent;

  text-align: left;

  cursor: pointer;

  transition:
    background 0.5s ease-in-out,
    color 0.5s ease-in-out;
}

.acao-modal:hover {
  background: var(--roxo-primario);
  color: var(--branco);
}

.acao-modal:hover .icone-acao {
  color: var(--roxo-primario);
  background: var(--branco);
}

.icone-acao {
  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  width: 38px;
  height: 38px;

  border-radius: 9px;

  color: var(--roxo-medio);
  background: var(--roxo-superficie);

  transition:
    background 0.5s ease-in-out,
    color 0.5s ease-in-out;
}

.icone-acao i {
  font-size: 0.9rem;
}

.texto-acao {
  display: flex;
  flex: 1;

  flex-direction: column;

  gap: 2px;
}

.texto-acao strong {
  color: var(--preto);

  font-size: 0.8rem;
  font-weight: 700;
}

.texto-acao small {
  color: var(--cinza-escuro);

  font-size: 0.68rem;
  line-height: 1.3;
}

.acao-modal:hover .texto-acao strong {
  color: var(--branco);
}

.acao-modal:hover .texto-acao small {
  color: var(--cinza-claro);
}

.seta-acao {
  color: var(--cinza-medio);

  font-size: 0.65rem;

  transition: transform 0.5s ease-in-out;
}

.acao-modal:hover .seta-acao {
  transform: translateX(2px);

  color: var(--branco);
}

.acao-perigosa {
  transition:
    background 0.5s ease-in-out,
    color 0.5s ease-in-out;
}

.acao-perigosa:hover {
  background: var(--vermelho);
}

.acao-perigosa:hover .icone-acao {
  color: #b42318;
  background: #fde8e8;
}

.acao-perigosa .icone-acao {
  color: #b42318;
  background: #fde8e8;
}


.acao-perigosa .texto-acao strong {
  color: var(--preto);
}

.acao-perigosa:hover .seta-acao {
  color: var(--branco);
}

.sr-only {
  position: absolute;

  width: 1px;
  height: 1px;

  padding: 0;
  margin: -1px;

  overflow: hidden;

  clip: rect(0, 0, 0, 0);

  white-space: nowrap;

  border: 0;
}

@media (max-width: 768px) {
  .dashboard-header {
    align-items: flex-start;
    flex-direction: column;
  }


  .tabela-container {
    overflow-x: auto;
  }

  table {
    min-width: 760px;
  }

  .modal-opcoes {
    max-width: 100%;
  }
}


@media (max-width: 480px) {
  .modal-overlay {
    align-items: flex-end;

    padding: 0;
  }

  .modal-opcoes {
    max-width: none;

    border-radius: 15px 15px 0 0;

    animation: subirModal 0.2s ease;
  }

  @keyframes subirModal {
    from {
      opacity: 0;
      transform: translateY(20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .modal-header {
    padding: 18px;
  }

  .modal-acoes {
    padding: 8px;
  }
}
</style>
